// extracted by mini-css-extract-plugin
module.exports = {"button":"GhostLink_button__2jsK0","button__text":"GhostLink_button__text__1YBQ4"};